import { ReactChildren, ReactChild } from 'react'
import { Modal as AntModal } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes'
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle'
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { ModalWrapper } from './styled'

interface IProps {
  title: string
  close: () => void
  isOpen?: boolean
  isConfirmation?: boolean
  isInfo?: boolean
  maxwidth: number
  maxheight: number
  children: ReactChild | ReactChildren
  actions?: React.ReactNode
}

export const Modal = ({
  title,
  close,
  isOpen = true,
  isConfirmation = false,
  isInfo = false,
  maxwidth,
  maxheight,
  children,
  actions,
}: IProps) => {
  return (
    <ModalWrapper
      id="modal-wrapper"
      isconfirmation={String(isConfirmation)}
      isInfo={String(isInfo)}
      maxwidth={maxwidth}
      maxheight={maxheight}
    >
      <AntModal
        title={
          <>
            {isConfirmation && (
              <FontAwesomeIcon
                icon={faExclamationTriangle as IconProp}
                color="#faad14"
              />
            )}
            {isInfo && (
              <FontAwesomeIcon
                icon={faCircleInfo as IconProp}
                color="#0085FF"
              />
            )}
            {title}
          </>
        }
        visible={isOpen}
        footer={actions ? actions : <></>}
        onCancel={close}
        closeIcon={<FontAwesomeIcon icon={faTimes as IconProp} />}
        getContainer={() =>
          document.getElementById('modal-wrapper') as HTMLElement
        }
        centered
      >
        {children}
      </AntModal>
    </ModalWrapper>
  )
}
